import React from 'react';
import { LegalLayout } from '../components/Layout';
export const TermsPage = () => <LegalLayout title="Terms and Conditions" lastUpdated="January 2026" data-id="element-578">
    <div className="space-y-8" data-id="element-579">
      <p className="text-gray-300 leading-relaxed" data-id="element-580">
        These Terms and Conditions govern your use of KDX. By accessing or using
        KDX, you agree to be bound by these terms.
      </p>

      <section data-id="element-581">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-582">Eligibility</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-583">
          You must be at least 18 years old and capable of entering into legally
          binding agreements. By using KDX, you confirm that all information
          provided is accurate.
        </p>
      </section>

      <section data-id="element-584">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-585">
          Account Registration and Security
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-586">
          You are responsible for maintaining the confidentiality of your
          account credentials. KDX will not be liable for unauthorized access
          resulting from your failure to secure your account.
        </p>
      </section>

      <section data-id="element-587">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-588">Services</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-589">
          KDX provides digital services including game top-ups, gift cards,
          airtime, data, utility payments, and marketplace transactions. All
          services are subject to availability and verification checks.
        </p>
      </section>

      <section data-id="element-590">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-591">
          Payments and Processing
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-592">
          All payments are processed through secure third-party payment
          providers, including but not limited to our payment processors. By
          making a payment, you authorize KDX and its payment partners to
          process your transaction.
        </p>
      </section>

      <section data-id="element-593">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-594">Transactions</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-595">
          Transactions are processed instantly where possible. You are
          responsible for verifying all transaction details before confirming
          payment.
        </p>
      </section>

      <section data-id="element-596">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-597">Pricing and Fees</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-598">
          All prices displayed are final unless otherwise stated. Applicable
          fees, taxes, or charges may apply depending on the service.
        </p>
      </section>

      <section data-id="element-599">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-600">Refund Policy</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-601">
          Refunds are only applicable for failed, incomplete, or duplicate
          transactions. Successfully completed transactions are non-refundable
          unless required by law.
        </p>
      </section>

      <section data-id="element-602">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-603">
          Prohibited Activities
        </h2>
        <p className="text-gray-300 leading-relaxed mb-4" data-id="element-604">You agree not to:</p>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-605">
          <li data-id="element-606">Engage in fraud or chargeback abuse</li>
          <li data-id="element-607">Use stolen payment methods</li>
          <li data-id="element-608">Attempt to exploit platform vulnerabilities</li>
          <li data-id="element-609">Conduct unauthorized reselling or arbitrage</li>
          <li data-id="element-610">Violate any applicable laws or regulations</li>
        </ul>
        <p className="text-gray-300 leading-relaxed mt-4" data-id="element-611">
          KDX reserves the right to suspend or terminate accounts involved in
          such activities.
        </p>
      </section>

      <section data-id="element-612">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-613">
          Compliance and KYC
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-614">
          KDX may require identity verification (KYC) to comply with regulatory
          requirements and prevent fraud. Failure to provide requested
          information may result in restricted access.
        </p>
      </section>

      <section data-id="element-615">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-616">
          Limitation of Liability
        </h2>
        <p className="text-gray-300 leading-relaxed mb-4" data-id="element-617">
          KDX is not liable for:
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-618">
          <li data-id="element-619">User input errors</li>
          <li data-id="element-620">Third-party service failures</li>
          <li data-id="element-621">Network or system interruptions</li>
          <li data-id="element-622">Indirect or consequential losses</li>
        </ul>
      </section>

      <section data-id="element-623">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-624">Termination</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-625">
          KDX may suspend or terminate access at its discretion for violations
          of these terms or regulatory requirements.
        </p>
      </section>

      <section data-id="element-626">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-627">Governing Law</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-628">
          These terms are governed by applicable laws and regulations in the
          operating jurisdiction.
        </p>
      </section>
    </div>
  </LegalLayout>;
export const LegalTermsPage = () => <LegalLayout title="Legal Terms of Use" lastUpdated="January 2026" data-id="element-629">
    <div className="space-y-8" data-id="element-630">
      <p className="text-gray-300 leading-relaxed" data-id="element-631">
        This document governs your access to and use of the KDX platform.
      </p>

      <section data-id="element-632">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-633">Permitted Use</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-634">
          You agree to use KDX only for lawful and authorized purposes.
        </p>
      </section>

      <section data-id="element-635">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-636">Restrictions</h2>
        <p className="text-gray-300 leading-relaxed mb-4" data-id="element-637">You must not:</p>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-638">
          <li data-id="element-639">Reverse engineer or interfere with platform operations</li>
          <li data-id="element-640">Access the system without authorization</li>
          <li data-id="element-641">Use automated bots or scraping tools</li>
          <li data-id="element-642">Attempt to bypass security mechanisms</li>
        </ul>
      </section>

      <section data-id="element-643">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-644">
          Intellectual Property
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-645">
          All content, branding, and system design belong to KDX and are
          protected by law.
        </p>
      </section>

      <section data-id="element-646">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-647">
          Third-Party Services
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-648">
          KDX integrates with third-party providers such as payment processors
          and API services. KDX is not responsible for the performance or
          policies of these providers.
        </p>
      </section>

      <section data-id="element-649">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-650">
          Service Availability
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-651">
          KDX may update, suspend, or discontinue services without prior notice.
        </p>
      </section>
    </div>
  </LegalLayout>;
export const PrivacyPage = () => <LegalLayout title="Privacy Policy" lastUpdated="January 2026" data-id="element-652">
    <div className="space-y-8" data-id="element-653">
      <p className="text-gray-300 leading-relaxed" data-id="element-654">
        KDX is committed to protecting your personal data.
      </p>

      <section data-id="element-655">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-656">
          Information Collected
        </h2>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-657">
          <li data-id="element-658">Personal details such as name, email, and phone number</li>
          <li data-id="element-659">Transaction data and payment records</li>
          <li data-id="element-660">Device and usage data</li>
        </ul>
      </section>

      <section data-id="element-661">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-662">
          Purpose of Collection
        </h2>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-663">
          <li data-id="element-664">To process transactions</li>
          <li data-id="element-665">To improve services</li>
          <li data-id="element-666">To detect and prevent fraud</li>
          <li data-id="element-667">To comply with legal obligations</li>
        </ul>
      </section>

      <section data-id="element-668">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-669">Data Sharing</h2>
        <p className="text-gray-300 leading-relaxed mb-4" data-id="element-670">
          Your data may be shared with:
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-671">
          <li data-id="element-672">Payment processors</li>
          <li data-id="element-673">Regulatory authorities where required</li>
          <li data-id="element-674">Service providers supporting operations</li>
        </ul>
      </section>

      <section data-id="element-675">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-676">Data Security</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-677">
          KDX implements industry-standard security measures to protect user
          data.
        </p>
      </section>

      <section data-id="element-678">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-679">User Rights</h2>
        <p className="text-gray-300 leading-relaxed mb-4" data-id="element-680">
          You have the right to:
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-681">
          <li data-id="element-682">Access your data</li>
          <li data-id="element-683">Request correction</li>
          <li data-id="element-684">Request deletion where applicable</li>
        </ul>
      </section>

      <section data-id="element-685">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-686">Data Retention</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-687">
          Data is retained only as long as necessary for business and legal
          purposes.
        </p>
      </section>
    </div>
  </LegalLayout>;
export const CookiePolicyPage = () => <LegalLayout title="Cookie Policy" lastUpdated="January 2026" data-id="element-688">
    <div className="space-y-8" data-id="element-689">
      <p className="text-gray-300 leading-relaxed" data-id="element-690">
        KDX uses cookies to enhance user experience.
      </p>

      <section data-id="element-691">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-692">Types of Cookies</h2>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-693">
          <li data-id="element-694">Essential cookies for functionality</li>
          <li data-id="element-695">Analytics cookies for performance tracking</li>
          <li data-id="element-696">Preference cookies for personalization</li>
        </ul>
      </section>

      <section data-id="element-697">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-698">User Control</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-699">
          Users can manage cookie preferences through browser settings.
        </p>
      </section>
    </div>
  </LegalLayout>;
export const PrivacyChoicesPage = () => <LegalLayout title="Your Privacy Choices" lastUpdated="January 2026" data-id="element-700">
    <div className="space-y-8" data-id="element-701">
      <p className="text-gray-300 leading-relaxed mb-6" data-id="element-702">You may control:</p>

      <section data-id="element-703">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-704">Privacy Controls</h2>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-705">
          <li data-id="element-706">Marketing communications</li>
          <li data-id="element-707">Data tracking preferences</li>
          <li data-id="element-708">Account data access</li>
        </ul>
      </section>

      <section data-id="element-709">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-710">Data Requests</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-711">
          Requests for data access or deletion can be submitted through support.
        </p>
      </section>
    </div>
  </LegalLayout>;
export const CodeOfConductPage = () => <LegalLayout title="Code of Conduct" lastUpdated="January 2026" data-id="element-712">
    <div className="space-y-8" data-id="element-713">
      <section data-id="element-714">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-715">
          User Responsibilities
        </h2>
        <p className="text-gray-300 leading-relaxed mb-4" data-id="element-716">Users must:</p>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-717">
          <li data-id="element-718">Act in good faith</li>
          <li data-id="element-719">Avoid fraudulent activities</li>
          <li data-id="element-720">Respect platform rules</li>
          <li data-id="element-721">Not abuse promotions or rewards</li>
        </ul>
      </section>

      <section data-id="element-722">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-723">Consequences</h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-724">
          Violations may result in suspension or permanent bans.
        </p>
      </section>
    </div>
  </LegalLayout>;
export const RewardsRulesPage = () => <LegalLayout title="Rules and Rewards" lastUpdated="January 2026" data-id="element-725">
    <div className="space-y-8" data-id="element-726">
      <p className="text-gray-300 leading-relaxed" data-id="element-727">
        KDX may offer promotional incentives.
      </p>

      <section data-id="element-728">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-729">Conditions</h2>
        <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4" data-id="element-730">
          <li data-id="element-731">Subject to eligibility and verification</li>
          <li data-id="element-732">May have expiration dates</li>
          <li data-id="element-733">Cannot be abused or manipulated</li>
        </ul>
      </section>

      <section data-id="element-734">
        <h2 className="text-2xl font-bold text-white mb-4" data-id="element-735">
          Platform Discretion
        </h2>
        <p className="text-gray-300 leading-relaxed" data-id="element-736">
          KDX reserves full discretion to modify or withdraw rewards.
        </p>
      </section>
    </div>
  </LegalLayout>;